import React, { useState } from 'react';
import DrinkAdminForm from './DrinkAdminForm';
import useApiStable from '../../utils/useApiStable';

function DrinkAdmin({ drinks, onRefresh }) {
    const [editing, setEditing] = useState(null); // null | 'new' | drink object
    const [deleting, setDeleting] = useState(null);
    const [error, setError] = useState('');
    const api = useApiStable();

    const handleDelete = (drink) => {
        if (!window.confirm(`"${drink.name}" wirklich löschen?`)) return;
        setError('');
        setDeleting(drink.id);
        api.delete(`/drinks/${drink.id}`)
            .then(() => { onRefresh(); setEditing(null); })
            .catch(err => setError(err.message || 'Fehler beim Löschen'))
            .finally(() => setDeleting(null));
    };

    const handleSave = () => {
        setEditing(null);
        onRefresh();
    };

    return (
        <section className="drink-admin">
            <h3>Getränke verwalten</h3>
            {error && <div className="drink-admin-error">{error}</div>}
            <table className="drink-admin-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Preis</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {drinks.map(drink => (
                        <React.Fragment key={drink.id}>
                            <tr>
                                <td>{drink.name}</td>
                                <td>{Number(drink.price).toFixed(2)} €</td>
                                <td className="drink-admin-actions">
                                    <button
                                        className="drink-admin-edit-btn"
                                        onClick={() => setEditing(editing?.id === drink.id ? null : drink)}
                                    >
                                        Bearbeiten
                                    </button>
                                    <button
                                        className="drink-admin-delete-btn"
                                        onClick={() => handleDelete(drink)}
                                        disabled={deleting === drink.id}
                                    >
                                        Löschen
                                    </button>
                                </td>
                            </tr>
                            {editing?.id === drink.id && (
                                <tr>
                                    <td colSpan={3}>
                                        <DrinkAdminForm
                                            drink={drink}
                                            onSave={handleSave}
                                            onCancel={() => setEditing(null)}
                                        />
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
            {editing === 'new' ? (
                <DrinkAdminForm
                    drink={null}
                    onSave={handleSave}
                    onCancel={() => setEditing(null)}
                />
            ) : (
                <button className="drink-admin-new-btn" onClick={() => setEditing('new')}>
                    + Neues Getränk
                </button>
            )}
        </section>
    );
}

export default DrinkAdmin;
